"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GET_BROADCAST_ROLES_WITH_USERS = void 0;
var GET_BROADCAST_ROLES_WITH_USERS = exports.GET_BROADCAST_ROLES_WITH_USERS = 'GET_BROADCAST_ROLES_WITH_USERS';